import { render } from "./QuestionnaireFormModal.vue?vue&type=template&id=22c563e3&scoped=true"
import script from "./QuestionnaireFormModal.vue?vue&type=script&lang=js"
export * from "./QuestionnaireFormModal.vue?vue&type=script&lang=js"

import "./QuestionnaireFormModal.vue?vue&type=style&index=0&id=22c563e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c563e3"]])

export default __exports__